export const FETCH = "FETCH";
export const CREATE = "CREATE";
export const  UPDATE = "UPDATE";
export const  DELETE = "DELETE";
export const SEARCH = "SEARCH";
export const SORT = "SORT";
